<div class="l-top-navi l-top-navi--not-back">
  <div class="l-wrap l-wrap--sp-tb-full">
    <div class="l-wrap__inner">
      <div class="l-top-navi__inner">
        <div *ngIf="this.isBack" class="l-top-navi__back-area">
          <button
            class="l-top-navi__back-link"
            id="ana-biz-application-list-sub-header-back"
            (click)="navigateAnaBizCompanyDataMaintenanceMenu()"
            [attr.aria-label]="'reader.goBackToPreviousPage' | staticMsg"
          ></button>
        </div>
        <div class="l-top-navi__heading-area">
          <h1 class="l-top-navi__heading-text" innerHTML="{{ 'heading.anaBizTicketingList' | staticMsg }}"></h1>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="l-page-tab-style01">
  <div class="l-wrap">
    <div class="l-wrap__inner">
      <div class="l-page-tab-style01__menu" role="tablist">
        <button
          class="l-page-tab-style01__menu-item"
          [ngClass]="{ 'is-current': activeApproverNum === 0 }"
          type="button"
          id="tab1_1"
          role="tab"
          aria-controls="panel1_1"
          [attr.aria-selected]="activeApproverNum === 0"
          [attr.tabindex]="activeApproverNum === 0 ? 0 : -1"
          (click)="approverTabClick(0)"
        >
          <span class="l-page-tab-style01__menu-label">{{ 'label.myApproveList' | staticMsg }}</span>
        </button>
        <button
          class="l-page-tab-style01__menu-item"
          [ngClass]="{ 'is-current': activeApproverNum === 1 }"
          type="button"
          id="tab1_2"
          role="tab"
          aria-controls="panel1_2"
          [attr.aria-selected]="activeApproverNum === 1"
          [attr.tabindex]="activeApproverNum === 1 ? 0 : -1"
          (click)="approverTabClick(1)"
        >
          <span class="l-page-tab-style01__menu-label">{{ "label.allApprovers'List" | staticMsg }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
